import React from 'react';
import Header from './Header'
import Page from './Page';
import Footer from './Footer';



function MainPage() {
   
 
    
  return (
    <div >
        <Header/>
        <Page/>
        <Footer/>
    
    </div>
    
  );
}

export default MainPage;
